import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { LoginService } from './login.service';
import { RestService } from './rest.service';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { Invoice } from '../models/invoice';

@Injectable()
export class InvoiceService {

  constructor(
    private restService: RestService,
    private http: Http,
    private loginService: LoginService
  ) {}

  getAll(): Observable<Invoice[]> {
    const endPoint = this.restService.endPoints.INVOICE;
    endPoint.setParams(['token=' + this.loginService.getUserToken()]);
    return this.http
      .get(endPoint.getUrl())
      .map(res => res.json())
      .catch(error => {
        if (error.status === 403) {
          this.loginService.logout();
        }
        return Observable.throw(error.json().error || 'Server error');
      });

  }

}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/services/invoice.service.ts